import { useAuth } from "src/hooks/useAuth";

const useIsLoggedIn = (): boolean => {
  const { isLoggedIn } = useAuth();
  return isLoggedIn;
};

function useNewIsLoggedIn(): {
  isLoggedIn: boolean;
  isSessionLoading: boolean;
} {
  const { isLoggedIn, isLoading } = useAuth();
  return { isLoggedIn, isSessionLoading: isLoading };
}

export { useIsLoggedIn, useNewIsLoggedIn };
